import supabase from "../services/supabaseClient";

export const DEFAULT_AVATAR = { skin: 0, hair: 0, hairColor: 0, outfit: 0, name: "" };

/** Default profile when onboarding quiz is skipped (new users). */
export function buildSkippedUserProfile(overrides = {}) {
  return {
    declared_motivation: "unknown",
    declared_time_perception: "unknown",
    declared_chronotype: "unknown",
    declared_initiation: "unknown",
    declared_hyperfocus: "unknown",
    declared_rsd_sensitivity: "unknown",
    declared_primary_challenge: "unknown",
    declared_focus_environment: "unknown",
    declared_recovery: "unknown",
    declared_structure: "unknown",
    skipped_quiz: true,
    avatar: DEFAULT_AVATAR,
    terms_privacy_accepted:false,
    nda_accepted:false,
    age_confirmed:false,
    legal_accepted_at: null,
    ...overrides,
  };
}

export async function upsertSkippedUserProfile(userId, profile = buildSkippedUserProfile()) {
  const { error } = await supabase.from("user_profile").upsert(
    {
      user_id: userId,
      ...profile,
      updated_at: new Date().toISOString(),
    },
    { onConflict: "user_id" }
  );
  if (error) console.error("upsertSkippedUserProfile:", error);
  return error;
}
